export const BEFORE_CONNECT = 'stimulus-controller-before-connect';
